import React from 'react'

export const DesktopIcon = () => (
  <svg
    width="39"
    height="23"
    viewBox="0 0 39 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M34.8656 19.6004V4.40541C34.8656 2.36749 33.2091 0.710938 31.1711 0.710938H8.51566C6.47774 0.710938 4.82119 2.36749 4.82119 4.40541V19.6004C0.375899 19.6004 0.673841 22.7109 0.673841 22.7109H38.8104C38.8104 19.1714 34.8656 19.6004 34.8656 19.6004ZM31.8028 19.0999H7.68142V4.44117C7.68142 3.78569 8.2058 3.26132 8.86127 3.26132H30.6229C31.2784 3.26132 31.8028 3.78569 31.8028 4.44117V19.1118V19.0999Z"
      fill="currentColor"
    />
  </svg>
)

export const TabletIcon = () => (
  <svg
    width="22"
    height="24"
    viewBox="0 0 22 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.4114 0H3.68916C2.09486 0 0.810303 1.29367 0.810303 2.87886V20.5438C0.810303 22.1381 2.10397 23.4226 3.68916 23.4226H18.4114C20.0057 23.4226 21.2903 22.129 21.2903 20.5438V2.87886C21.2903 1.28456 19.9966 0 18.4114 0ZM19.2314 20.5073C19.2314 21.0175 18.8214 21.4275 18.3112 21.4275H3.90781C3.39763 21.4275 2.98767 21.0175 2.98767 20.5073V2.87886C2.98767 2.36868 3.39763 1.95872 3.90781 1.95872H18.3112C18.8214 1.95872 19.2314 2.36868 19.2314 2.87886V20.5073Z"
      fill="currentColor"
    />
    <path
      d="M14.0385 17.6367H8.14417V19.641H14.0385V17.6367Z"
      fill="currentColor"
    />
  </svg>
)

export const MobileIcon = () => (
  <svg
    width="15"
    height="23"
    viewBox="0 0 15 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.7919 0.494141H2.82875C1.42825 0.494141 0.290344 1.63204 0.290344 3.03254V20.39C0.290344 21.7905 1.42825 22.9284 2.82875 22.9284H11.7919C13.1924 22.9284 14.3303 21.7905 14.3303 20.39V3.03254C14.3303 1.63204 13.1924 0.494141 11.7919 0.494141ZM12.4309 20.1711C12.4309 20.6613 12.037 21.064 11.5381 21.064H3.13511C2.64493 21.064 2.24229 20.6701 2.24229 20.1711V3.29514C2.24229 2.80496 2.63618 2.40231 3.13511 2.40231H11.5381C12.0283 2.40231 12.4309 2.79621 12.4309 3.29514V20.1711Z"
      fill="currentColor"
    />
    <path
      d="M8.737 17.3164H5.88348V19.5222H8.737V17.3164Z"
      fill="currentColor"
    />
  </svg>
)

export const CloseIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path
      d="M13 1L1 13M1 1L13 13"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
